export default __webpack_public_path__ + "static/media/CNo.38-4.0dac7651.jpg";